export const SKIP_WAITING_MESSAGE = { type: 'SKIP_WAITING' };
export const SW_GENERATION_CACHE = 'sw-generation-2';
const CONTROLLER_CHANGE_TIMEOUT_MS = 10000;

export function getWaitingWorker(
  registration?: ServiceWorkerRegistration | null,
): ServiceWorker | null {
  return registration?.waiting ?? null;
}

export function activateWaitingWorker(
  registration?: ServiceWorkerRegistration | null,
  timeoutMs: number = CONTROLLER_CHANGE_TIMEOUT_MS,
): Promise<void> {
  const waiting = getWaitingWorker(registration);
  const container = navigator.serviceWorker;

  if (!waiting || !container) {
    return Promise.reject(new Error('No waiting service worker to activate'));
  }

  return new Promise<void>((resolve, reject) => {
    const onControllerChange = (): void => {
      cleanup();
      resolve();
    };
    const timer = setTimeout(() => {
      cleanup();
      reject(new Error('Service worker did not take control in time'));
    }, timeoutMs);
    const cleanup = (): void => {
      clearTimeout(timer);
      container.removeEventListener('controllerchange', onControllerChange);
    };

    container.addEventListener('controllerchange', onControllerChange);
    waiting.postMessage(SKIP_WAITING_MESSAGE);
  });
}
